import { create } from "zustand";

type TEmailAiInboxStore = {
  selectedInboxes: string[];
  hasAppliedDefaultInbox: boolean;
  setSelectedInboxes: (emails: string[]) => void;
  applyDefaultInbox: (email: string) => void;
  resetSelectedInboxes: () => void;
};

// Shared across the Email AI tabs: each tab panel unmounts when you switch away
// (Tabs keepMounted={false}), so the selection has to live outside MailboxTab to
// survive the round trip.
export const useEmailAiInboxStore = create<TEmailAiInboxStore>((set) => ({
  selectedInboxes: [],
  hasAppliedDefaultInbox: false,
  setSelectedInboxes: (emails) => set({ selectedInboxes: emails }),
  // SERV-3241: every user may read their own mailbox, so Email AI opens on it.
  // Applied once per session: a user who clears it on purpose keeps it cleared
  // across tab switches, and a selection already made is never overwritten.
  applyDefaultInbox: (email) =>
    set((state) =>
      state.hasAppliedDefaultInbox
        ? state
        : {
            hasAppliedDefaultInbox: true,
            selectedInboxes: state.selectedInboxes.length > 0 ? state.selectedInboxes : [email],
          },
    ),
  resetSelectedInboxes: () => set({ selectedInboxes: [], hasAppliedDefaultInbox: false }),
}));
